import { useLocation } from 'react-router-dom';

const useIsConstructor = () => {
  const location = useLocation();

  return !!location.pathname.match(/constructor/g);
};

export default useIsConstructor;
